import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '../../atoms/Button';
import Content from '../../atoms/Content';
var PaginationLink = function PaginationLink(props) {
  var changePage = props.changePage,
    pageNumber = props.pageNumber,
    isDisabled = props.isDisabled,
    isActive = props.isActive;
  var clickHandler = function clickHandler() {
    return changePage(pageNumber);
  };
  return /*#__PURE__*/React.createElement(Button, {
    className: cx('pagination-element pagination-element-link', {
      'is-disabled': isDisabled,
      'is-active': isActive
    }),
    view: Button.VIEW.TERTIARY,
    key: pageNumber,
    onClick: clickHandler
  }, /*#__PURE__*/React.createElement(Content, {
    className: cx('text', {
      'is-disabled': isDisabled,
      'is-active': isActive
    })
  }, pageNumber));
};
PaginationLink.propTypes = {
  changePage: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isActive: PropTypes.bool
};
PaginationLink.defaultProps = {
  isActive: false
};
export default PaginationLink;